import { AutodataTrackingTypes } from "./ts/types";

import { getDataEvent } from "../../autodata/src/helpers";

export default (domElements: HTMLElement[], autoData: AutoData) => {
  domElements.forEach(element =>
    autoData.sendPageView(getDataEvent(element, AutodataTrackingTypes.pageView))
  );
};
